export const BOOSTER_FEATURES: string[] = [
  'text_signUpBoosterListing0',
  'text_signUpBoosterListing2',
  'text_signUpBoosterListing1',
  'text_caching'
];

export const WEBSITE_FEATURES: string[] = [
  'text_deletionOfWebsite',
  'text_deletionOfAllFiles',
  'text_deletionOfDatabase',
  'text_deletionOfAllBackups',
  'text_deletionOfStagingSites',
  'text_deletedItemsNotRecoverable',
];

export const MULTISITE_FEATURES: string[] = [
  'text_deletionOfMultisite',
  'text_deletionOfAllFiles',
  'text_deletionOfDatabase',
  'text_deletionOfAllBackups',
  'text_deletionOfStagingSites',
  'text_deletedItemsNotRecoverable',
];

export const CONNECTED_FEATURES: string[] = [
  'text_scanningSecurity',
  'text_realtimeBackup',
  'text_speedUpWebsite90',
  'text_optimizeImages1Click',
  'text_automaticPluginUpdates',
];

export const IMAGE_OPTIMIZER_FEATURES: string[] = [
  'text_advancedImageOptimization',
  'text_optimization50KImages',
  'text_optimizationMediaLibrary'
];
